import React, { useContext } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { DataContext } from '../../components/Context/Context'
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper";
import formatCurrency from '../../components/Util/Util';
import "./DetailsProduct.css"
function DetailsProduct() {
    const { id } = useParams();
    const value = useContext(DataContext);
    const [products, setProducts] = value.products;
    const [index, setIndex] = useState(0);
    const addCart = value.addCart;
    const details = products.filter((product, index) => {
        return product._id === id;
    })
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    return (
        <>
            <div className="container-fluid bg-sec marginTop">
                <div className="container-xxl py-5 detailsProduct ">
                    <div className="row p-0 m-0 justify-content-center p-4 p-lg-0 ">
                        {
                            details.map(product => (
                                <div className="row col-12 col-lg-10  p-2 p-lg-4 py-4 style-sec rounded " key={product._id}>
                                    <div className="col-12 col-md-5 ">
                                        <div className="row">
                                            <div className="col-12">
                                                <Swiper
                                                    spaceBetween={10}
                                                    navigation={true}
                                                    thumbs={{ swiper: thumbsSwiper }}
                                                    modules={[FreeMode, Navigation, Thumbs]}
                                                    className="mySwiper2 rounded w-100"
                                                >
                                                    {
                                                        product.images.map(image => (
                                                            <SwiperSlide key={image} >
                                                                <img src={image} className='img-fluid w-100 h-100 rounded border p-4 bg-white' />
                                                            </SwiperSlide>
                                                        ))
                                                    }
                                                </Swiper>
                                                <Swiper
                                                    onSwiper={setThumbsSwiper}
                                                    spaceBetween={10}
                                                    slidesPerView={3}
                                                    freeMode={true}
                                                    watchSlidesProgress={true}
                                                    modules={[FreeMode, Navigation, Thumbs]}
                                                    className="mySwiper pt-2 d-none d-md-block" >
                                                    {
                                                        product.images.map((img) => (
                                                            <SwiperSlide className='thumImg border rounded' key={img}>
                                                                <img src={img} className='thumImg rounded p-2 bg-white' onClick={() => setIndex(index)} alt="" />
                                                            </SwiperSlide>
                                                        ))
                                                    }
                                                </Swiper>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-7 pt-4 pt-md-0">
                                        <div className="col-12">
                                            <div className="box-details">
                                                <h6 className='py-2'>{product.name}</h6>
                                                <h5 className='border-bottom py-3 nameProduct'>{product.fullName}</h5>
                                                <p className='py-5'>{product.content}</p>
                                                <h5 className='py-2 text-danger'>قیمت : {formatCurrency(product.price)} </h5>
                                                <div className="pt-5 text-center ">
                                                    <button className="btn btn-primary btn-cart p-2 px-4" onClick={() => addCart(product._id)}>
                                                        <i className="bi bi-handbag iconHB"></i>  افزودن به سبد خرید  </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>

        </>
    )
}

export default DetailsProduct